import InputWithLabelAndValidation from './InputWithLabelAndValidation'

export default InputWithLabelAndValidation
